/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import CarouselNextArrow from '../components/CarouselNextArrow';
import CarouselPreviousArrow from '../components/CarouselPreviousArrow';

// https://react-slick.neostack.com/docs/api
export const defaultCarouselSettings = {
  adaptiveHeight: true,
  centerMode: true,
  variableWidth: true,
  easing: 'ease',
  speed: '1000',
  nextArrow: <CarouselNextArrow />,
  prevArrow: <CarouselPreviousArrow />
};
